import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Set } from 'immutable'
import { reduxForm } from 'redux-form/immutable'
import { withTranslation } from 'react-i18next'

import { EDIT_STORY_FEED_FORM_NAME as FORM_NAME } from 'app/constants/activities'
import UserStoryForm from './UserStoryForm'
import { setFeatureAsShown } from 'store/entities/identity/actions'
import { getShowStoryTooltip } from 'store/entities/identity/selectors'
import { syncValidate as validate } from 'app/validators/stories/create'
import { getMentionUsersList } from 'store/entities/users/selectors'
import { getJoinedUserFullName } from 'helpers/getUserUIData'

const formProps = {
  form: FORM_NAME,
  validate,
  onSubmit: (
    values,
    dispatch,
    { activityId, userActivityId, mentionUsers, setStory, setCustomStory, setYesterdayStory, customSubmit }
  ) => {
    // depends of which activity we will send story. Must be one of setStory or setYesterdayStory
    const handleSubmit = customSubmit || setStory || setYesterdayStory || setCustomStory

    values = values.toJS()
    mentionUsers = Set(mentionUsers).toJS()
    let story = values.story
    const mentions = mentionUsers
      .filter(user => {
        const { firstName, lastName, email } = user
        const key = `@${getJoinedUserFullName(firstName, lastName, email)}`
        // Escaping characters that are used in regular expressions
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const reqExp = new RegExp(`(${escapedKey})([\\W]|$)`, 'g', 'm')
        if (reqExp.test(story)) {
          story = story.replace(reqExp, `<b>${key}</b> `)
          return true
        }
        return false
      })
      .map(user => user.id)
    handleSubmit({ activityId, userActivityId, story, mentions, ...values })
  },
}

const mapDispatchToProps = {
  setFeatureAsShown,
}

const mapStateToProps = createStructuredSelector({
  showTooltip: getShowStoryTooltip,
  mentionUsers: getMentionUsersList,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(formProps)(withTranslation('user')(UserStoryForm)))
